// src/redux/wpSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  getConnectedWABAs,
  getConversationList,
  sendWpMessage,
  getConversationById,
  WPDisconnect,
  updateWpStatus,
  wpDisconnect,
  getTemplates,
  getTemplatesById,
  createTemplates,
} from "./wpThunks";

const wpSlice = createSlice({
  name: "wp",
  initialState: {
    connectedWABAs: null,
    conversations: [],
    currentConversation: null,
    error: null,
    status: "idle",
    wpStatus: null,
    wpDisconnectmessage: null,
    disError: null,

    usergetTemplatesloading: null,
    usergetTemplatesError: null,
    usergetTemplatesFullfill: null,

    getTemplatesByIdloading: null,
    getTemplatesByIdError: null,
    getTemplatesByIdFullfill: null,

    createTemplatesloading: null,
    createTemplatesError: null,
    createTemplatesFullfill: null,
  },
  reducers: {
    resetHelpState: (state) => {
      state.getTemplatesByIdloading = false;
      state.getTemplatesByIdError = null;
      state.getTemplatesByIdFullfill = null;

      state.usergetTemplatesloading = false;
      state.usergetTemplatesError = null;
      state.usergetTemplatesFullfill = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConnectedWABAs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getConnectedWABAs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.connectedWABAs = action.payload;
      })
      .addCase(getConnectedWABAs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getConversationList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getConversationList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.conversations = action.payload;
      })
      .addCase(getConversationList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(sendWpMessage.pending, (state) => {
        state.status = "loading";
      })
      .addCase(sendWpMessage.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(sendWpMessage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getConversationById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getConversationById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.currentConversation = action.payload;
      })
      .addCase(getConversationById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // .addCase(WPDisconnect.pending, (state) => {
      //     state.status = 'loading';
      // })
      // .addCase(WPDisconnect.fulfilled, (state) => {
      //     state.status = 'succeeded';
      // })
      // .addCase(WPDisconnect.rejected, (state, action) => {
      //     state.status = 'failed';
      //     state.error = action.payload;
      // })

      .addCase(updateWpStatus.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateWpStatus.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateWpStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getTemplates.pending, (state) => {
        state.usergetTemplatesloading = true;
      })
      .addCase(getTemplates.fulfilled, (state, action) => {
        state.usergetTemplatesloading = false;
        state.usergetTemplatesFullfill = action.payload;
      })
      .addCase(getTemplates.rejected, (state, action) => {
        state.usergetTemplatesloading = false;
        state.usergetTemplatesError = action.payload;
      })

      .addCase(getTemplatesById.pending, (state) => {
        state.getTemplatesByIdloading = true;
      })
      .addCase(getTemplatesById.fulfilled, (state, action) => {
        state.getTemplatesByIdloading = false;
        state.getTemplatesByIdFullfill = action.payload;
      })
      .addCase(getTemplatesById.rejected, (state, action) => {
        state.getTemplatesByIdloading = false;
        state.getTemplatesByIdError = action.payload;
      })
      .addCase(createTemplates.pending, (state) => {
        state.createTemplatesloading = true;
        state.createTemplatesError  = null;
        state.createTemplatesFullfill  = null;

      }).addCase(createTemplates.fulfilled,(state,action)=>{
        state.createTemplatesloading = false;
        state.createTemplatesError  = null;
        state.createTemplatesFullfill  = action.payload;
      }).addCase(createTemplates.rejected,(state,action)=>{
        state.createTemplatesloading = false; 
        state.createTemplatesError  = action.payload;
        state.createTemplatesFullfill  = null;
      })

      .addCase(wpDisconnect.pending, (state) => {
        state.wpStatus = "loading";
      })

      .addCase(wpDisconnect.fulfilled, (state, action) => {
        state.wpStatus = "success";
        state.wpDisconnectmessage = action.payload;
      })

      .addCase(wpDisconnect.rejected, (state, action) => {
        state.wpStatus = "failed";
        state.disError = action.payload;
      });
  },
});

export default wpSlice.reducer;
